'use strict';
var ExpressCheckoutController = /** @class */ (function () {
    function ExpressCheckoutController($state, $scope, $q, $mdDialog, CreditCardService, CartService, AddressService, AddressListService, SettingsService, $rootScope, troveValidateaddressService, Auth) {
        'ngInject';
        var _this = this;
        this.showSubmitForm = true;
        this.showEditForm = false;
        this.loadingExpressCheckoutShipping = true;
        this.loadingExpressCheckoutNextStep = false;
        this.cartNotEmpty = false;
        this.subTotal = 0;
        this.paymentHasCreditCard = false;
        this.Auth = Auth;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.$scope = $scope;
        this.$q = $q;
        this.CreditCardService = CreditCardService;
        this.CartService = CartService;
        this.AddressService = AddressService;
        this.AddressListService = AddressListService;
        this.troveValidateaddressService = troveValidateaddressService;
        this.SettingsService = SettingsService;
        this.$rootScope = $rootScope;
        this.cart;
        this.userPaymentTypes = [];
        this.blockCheckOut = false;
        this.removingItem = false;
        this.selectedPaymentMethod;
        this.handleSubscription = {};
        var self = this;
        $rootScope.$on('$stateChangeStart', function () {
            _this.handleSubscription.unsubscribe();
        });
    }
    ;
    ExpressCheckoutController.prototype.$onInit = function () {
        var _this = this;
        this.Auth.getConfigUrl().then(function (config) {
            _this.troveValidateaddressService.AkrisApi = config.awsAkrisServiceUrlPattern.replace('{ServiceName}', 'shipping');
        });
        this.$rootScope.$on('removing item start', function () {
            _this.removingItem = true;
        });
        this.$rootScope.$on('removing item end', function () {
            _this.removingItem = false;
        });
        this.$rootScope.$on('express-checkout-mobile', function () {
            console.log('GOT THE EXPRESS CHECKOUT MOBILE EVENT');
            _this.goExpressCheckout(_this);
        });
        this.getAccountData();
        this.validateAddress();
    };
    ExpressCheckoutController.prototype.getAccountData = function () {
        var _this = this;
        var self = this;
        // subscribe function will update defaultShipMethod with setNewDeliveryMethod()
        this.CartService.subscribe(this.$scope, function (event, cart) {
            self.cart = cart;
            self.subTotal = cart.subTotal;
            _this.loadingExpressCheckoutShipping = false;
            if (cart.aresLineItems) {
                self.cartNotEmpty = (cart.aresLineItems.length > 0);
                self.hasItemLevelShippingIssue = _this.CartService.hasItemLevelShippingProblem(cart);
            }
        });
        self.$q.all([
            self.AddressService.getAddresses(),
            self.CreditCardService.getCreditCards(),
            self.SettingsService.getAccount()
        ])
            .then(function (responses) { return self.handleAccountData(self, responses); });
    };
    ExpressCheckoutController.prototype.handleAccountData = function (self, responses) {
        var _this = this;
        // Addresses responses[0]
        if (responses[0] !== null && typeof (responses[0]) === 'object') {
            var allAddress = responses[0].data.response.currentPage;
            self.addresses = allAddress.filter(function (address) {
                return _this.AddressService.isValidShippingCountries(address.countryCode);
            });
            ;
            self.hasAddresses = (self.addresses !== null && typeof (self.addresses) === 'object');
        }
        // paymentMethods
        self.paymentMethods = responses[1];
        self.hasPaymentMethods = (self.paymentMethods !== null && typeof (self.paymentMethods) === 'object');
        if (self.hasPaymentMethods) {
            self.paymentMethods.forEach(function (method, index, methods) {
                var paymentOption = method;
                if (paymentOption.paymentType == 'CreditCard') {
                    _this.paymentHasCreditCard = true;
                    _this.userPaymentTypes.push(paymentOption);
                }
                if (!method.cardNickName) {
                    methods[index].cardNickName = method.nameOnCard;
                }
                if (paymentOption.paymentType === 'Terms' ||
                    paymentOption.paymentType === 'COD' ||
                    paymentOption.paymentType === 'Prepaid') {
                    methods[index].cardNickName = method.paymentType;
                    methods[index].creditCardId = method.paymentType;
                    _this.userPaymentTypes.push(paymentOption); // more than 1 payment type
                    if (method.isDefaultPayment) {
                        _this.paymentLineOne = paymentOption.paymentType;
                        _this.paymentLineTwo = '';
                        _this.selectedPayment = method;
                        _this.CartService.addPayment(method, paymentOption.paymentType, null);
                    }
                }
                else if (method.isDefaultPayment) {
                    _this.CartService.ccType = method.paymentType;
                    _this.paymentLineOne = _this.CreditCardService.getCardType(method.paymentType);
                    _this.paymentLineTwo = 'xxxx xxxxxx' + method.last4Digits;
                    _this.selectedPayment = method;
                    _this.CartService.addPayment(method, 'CreditCard', null);
                }
            });
        }
        // Account responses[2]
        self.account = responses[2];
        self.blockCheckOut = self.account.blockCheckOut;
        self.hasAccountData = (self.account !== null && typeof (self.account) === 'object');
        if (self.hasAccountData) {
            self.updateDisplay(self.account);
        }
    };
    ExpressCheckoutController.prototype.updateDisplay = function (data) {
        this.customerId = data.customerId;
        this.defaultAddress = data.defaultShippingAddress;
        this.selectedAddress = data.defaultShippingAddress;
        this.defaultShipViaName = data.defaultShipVia;
        this.CartService.setNewDeliveryMethod(this);
    };
    ;
    ExpressCheckoutController.prototype.toggleEdit = function () {
        var _this = this;
        if (this.showEditForm) {
            var data = {};
            if (this.customerId) {
                data.customerId = this.customerId;
            }
            ;
            if (this.selectedPayment) {
                if (this.selectedPayment.creditCardId) {
                    data.defaultPayment = this.selectedPayment.creditCardId;
                }
            }
            ;
            if (this.otherPayType) {
                data.defaultPayment = this.otherPayType;
            }
            if (this.selectedAddress) {
                if (this.selectedAddress.addressId) {
                    this.AddressListService
                        .setDefaultAddress(this.selectedAddress.addressKey)
                        .then(function (response) {
                        // If address saved then save delivery method and credit card
                        _this.SettingsService.putAccount(data)
                            .then(function (response) {
                            _this.updateDisplay(response.data.response);
                            if (_this.loadingExpressCheckoutShipping) {
                                _this.loadingExpressCheckoutShipping = false;
                            }
                        });
                    });
                }
            }
            ;
        }
        this.showSubmitForm = !this.showSubmitForm;
        this.showEditForm = !this.showEditForm;
    };
    ExpressCheckoutController.prototype.triggerLoadingInfo = function () {
        this.loadingExpressCheckoutShipping = true;
    };
    ExpressCheckoutController.prototype.decideWhereToGo = function () {
        var goto = 'reviewOrder';
        this.CartService.setLinkStatus(goto);
        if (this.shippingOptionsProblem()) {
            goto = 'shippingAndDelivery';
            this.CartService.setLinkStatus(goto);
        }
        else if (this.paymentOptionsProblem()) {
            if (this.selectedPaymentMethod == 'Terms' || this.selectedPaymentMethod == 'COD' || this.selectedPaymentMethod == 'Prepaid') {
                goto = 'reviewOrder';
            }
            else {
                goto = 'payment';
            }
            this.CartService.setLinkStatus(goto);
        }
        return goto;
    };
    ExpressCheckoutController.prototype.getSelectedPaymentMethod = function () {
        this.selectedPaymentMethod = this.selectedPayment.paymentType;
    };
    ExpressCheckoutController.prototype.shippingOptionsProblem = function () {
        var isInternational;
        if (this.cart) {
            // check if address is international
            if (this.cart.shippingAddress) {
                isInternational = this.cart.shippingAddress.countryCode !== "US";
            }
        }
        return (isInternational ||
            !this.selectedAddress ||
            !this.defaultShipMethod ||
            this.hasItemLevelShippingIssue);
    };
    ExpressCheckoutController.prototype.paymentOptionsProblem = function () {
        var cardExpired = false;
        if (this.selectedPayment && this.selectedPayment.paymentType === "CreditCard") {
            // check if card is expired
            var today = new Date();
            var expDate = new Date();
            var dateStr = this.selectedPayment.expirationDate.split('/');
            expDate.setDate(1);
            if (dateStr[1].length === 4) {
                expDate.setMonth(dateStr[0] - 1);
                expDate.setFullYear(dateStr[1]);
            }
            else {
                expDate.setMonth(dateStr[1] - 1);
                expDate.setFullYear(dateStr[0]);
            }
            cardExpired = (today > expDate);
        }
        return (cardExpired || !this.selectedPayment);
    };
    ExpressCheckoutController.prototype.displayDate = function (str) {
        if (str && str.length === 10) {
            return this.CartService.displayDate(str);
        }
    };
    ExpressCheckoutController.prototype.goExpressCheckout = function () {
        if (this.selectedAddress.countryCode === 'US' && this.defaultShipMethod.shippingMethodId.indexOf('Standard') > -1 && this.subTotal >= 250) {
            this.defaultShipMethod.cost = 0;
        }
        if (this.selectedAddress.countryCode === 'US') {
            var address = this.defaultAddress;
            this.troveValidateaddressService.checkaddress({
                "street1": address.line1,
                "street2": address.line2,
                "postalcode": this.formatPostalCodeForUS(address),
                "city": address.city,
                "regionCode": address.regionCode,
                "countryCode": address.countryCode,
                "isDefault": address.isDefault,
                "showNextStep": true,
                "isNewAddress": address.isAddressValidationOptOut != true
            });
        }
        else {
            this.CartService.goExpressCheckout(this);
            sessionStorage.setItem('expressCheckoutStatus', true);
        }
    };
    ExpressCheckoutController.prototype.triggerLoadingNextStep = function () {
        this.loadingExpressCheckoutNextStep = true;
    };
    ExpressCheckoutController.prototype.validateAddress = function () {
        var _this = this;
        var expressCheckout = function () {
            _this.CartService.goExpressCheckout(_this);
            sessionStorage.setItem('expressCheckoutStatus', true);
        };
        this.handleSubscription = this.troveValidateaddressService.selectedAddress().subscribe(function (data) {
            var isRenterAddress = false;
            switch (data.eventtype) {
                case 0: {
                    break;
                }
                case 1: {
                    _this.defaultAddress.isAddressValidationOptOut = data.userOptOut ? data.userOptOut : _this.defaultAddress.isAddressValidationOptOut;
                    break;
                }
                case 2: {
                    isRenterAddress = true;
                    _this.loadingExpressCheckoutNextStep = false;
                    break;
                }
                case 3: {
                    var address = data.selectedaddress;
                    _this.defaultAddress.line1 = address.street1;
                    _this.defaultAddress.line2 = address.street2;
                    _this.defaultAddress.postalCode = address.postalCode.replace('-', '');
                    _this.defaultAddress.regionCode = address.regionCode;
                    _this.defaultAddress.city = address.city;
                    _this.defaultAddress.isDefault = address.isDefault;
                    break;
                }
                case 5: {
                    isRenterAddress = true;
                    _this.loadingExpressCheckoutNextStep = false;
                    alert = _this.$mdDialog.alert({
                        title: 'Alert',
                        textContent: 'Please re-enter address.',
                        ok: 'Close'
                    });
                    _this.$mdDialog
                        .show(alert)
                        .finally(function () {
                        alert = undefined;
                    });
                    break;
                }
            }
            if (data.eventtype == 3) {
                _this.AddressService.updateAddress(_this.defaultAddress).then(expressCheckout);
            }
            else if (!isRenterAddress)
                expressCheckout();
        });
    };
    ExpressCheckoutController.prototype.formatPostalCodeForUS = function (address) {
        return (address.postalCode.length > 5 &&
            address.countryCode === 'US'
            ? address.postalCode.substr(0, 5) +
                '-' + address.postalCode.substr(5)
            : address.postalCode);
    };
    return ExpressCheckoutController;
}());
export default ExpressCheckoutController;
//# sourceMappingURL=express-checkout.controller.js.map